//
// PartBase
//
import { mapMutations } from 'vuex'
import * as time from '@/libs/time'

export default {
  data () {
    return {
      BREAKPOINT_XS: 0,
      BREAKPOINT_SM: 1,
      BREAKPOINT_MD: 2,
      BREAKPOINT_LG: 3,
      BREAKPOINT_XL: 4
    }
  },
  computed: {
    //
    // breakpoint 名を返す
    //
    breakpointName () {
      return this.$vuetify.breakpoint.name
    },

    //
    // breakpoint のコードを返す
    //
    breakpoint () {
      switch (this.$vuetify.breakpoint.name) {
        case 'sm': return this.BREAKPOINT_SM
        case 'md': return this.BREAKPOINT_MD
        case 'lg': return this.BREAKPOINT_LG
        case 'xl': return this.BREAKPOINT_XL
      }
      return this.BREAKPOINT_XS
    }
  },
  filters: {
    comma (n) {
      return ((n || 0) - 0).toLocaleString()
    },
    timeformat (tm, fmt) {
      return time.format(fmt, tm)
    }
  },
  methods: {
    ...mapMutations([
      'statePrepared',
      'stateAddErrors'
    ])
  }
}
